import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import feather from "feather-icons";
import { Arc, Habit, db } from "../services/db";

export default function Today() {
  const [habits, setHabits] = useState<Habit[]>([]);
  const [arcNames, setArcNames] = useState<Record<string, string>>({});
  const [arcs, setArcs] = useState<Arc[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const habitsForToday = await db.getHabitsForToday();
        const allArcs = await db.getAllArcs();
        setArcs(allArcs);
        setHabits(habitsForToday);
        feather.replace(); // Call feather.replace() once data is fetched
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchArcNames = async () => {
      const arcNamesMap: Record<string, string> = {};
      try {
        for (const habit of habits) {
          const arcName = await getArcById(habit.arcId);
          arcNamesMap[habit.id] = arcName;
        }
        setArcNames(arcNamesMap);
      } catch (error) {
        console.error("Error fetching arc names:", error);
      }
    };

    fetchArcNames();
  }, [habits]);

  const date = new Date();
  const dateString = date.toLocaleDateString();

  const markHabitCompleted = async (habitId: string, arcId: string) => {
    try {
      await db.markHabitCompleted(habitId, arcId, dateString);
      const updatedHabits = await db.getHabitsForToday();
      setHabits(updatedHabits);
    } catch (error) {
      console.error("Error marking habit as completed:", error);
    }
  };

  const getArcById = async (arcId: string): Promise<string> => {
    const arc = arcs.find((arc) => arc.arcId === arcId);
    return arc ? arc.name : "";
  };

  return (
    <div className="p-6 ">
      <h2 className="text-3xl font-bold mb-4 text-left">Today's Habits</h2>
      {habits.length > 0 ?
        habits.map((habit, index) => (
          <div
            key={habit.id}
            className="flex justify-between items-center bg-white p-4 rounded-lg shadow-lg mb-4"
          >
            <div className="text-lg flex justify-center flex-col items-start">
              <p className="text-2xl">{habit.name}</p>
              <p className="font-bold text-lg">{arcNames[habit.id]}</p>
            </div>
            <button
              onClick={() => markHabitCompleted(habit.id!, habit.arcId)}
              className="btn btn-primary"
            >
              <i data-feather="check-circle"></i>
            </button>
          </div>
        )) : <div>
          <p className="text-2xl">No habits for today!!</p>
          </div>}
    </div>
  );
}
